module.exports = __webpack_public_path__ + "static/img/technology-1.4baa64ed.png";